/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-incident-list[_ngcontent-%COMP%]   .grow[_ngcontent-%COMP%]{flex-grow:1}app-incident-list[_ngcontent-%COMP%]   .actions[_ngcontent-%COMP%]{text-align:right;margin-top:30px;margin-bottom:60px}.incident-details[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
